export enum Roles {
  Parent = 'parent',
  CareProfessional = 'careProfessional',
  Educator = 'educator'
}

export interface IUserData {
  avatar_url: string
  email: string
  full_name: string
  role: Roles
  terms_not_accepted?: boolean
  userId: string
}

export interface IParentData {
  created_at: number
  email: string
  enabled: boolean
  first_name: string
  id_parent: string
  last_name: string
  name: string
  parental_instructions_complete: boolean
  phone: string
  updated_at: number

  children?: any[]
}

export type User = IUserData & IParentData



// WEBPACK FOOTER //
// ./src/data/user/user.ts